import isEmpty from 'lodash/isEmpty';
import React from 'react';
import ReactDOM from 'react-dom';
import StorageUtils from 'storage-utils';
import GooglePlacesSearchInput from 'search/components/common/GooglePlacesSearchInput';
import SearchByAddress from 'search-by-address';

let $latitude = null;
let $longitude = null;
let $googlePlacesId = null;
let $googlePlacesPlaceId = null;
let $googlePlacesReference = null;
let $submitSearch = null;
let $searchByAddressForm = null;
let $token = null;
let $searchString = null;

const SHGooglePlacesSearch = {
    init({size, searchValue, placeholder, focus} = {}) {
        const gmaps = window.google.maps;
        const bounds = (window.includeACBounds)
            ? new gmaps.LatLngBounds(
                new gmaps.LatLng(window.sw_lat, window.sw_lng),
                new gmaps.LatLng(window.ne_lat, window.ne_lng)
            )
            : null;
        const searchInputContainerElement = document.querySelector('.google-places-search-input');
        const searchInputElement = searchInputContainerElement.querySelector('.Textfield-input');
        const value = (searchInputElement && searchInputElement.value)
            ? searchInputElement.value
            : searchValue;
        let component;

        $latitude = $('#latitude');
        $longitude = $('#longitude');
        $googlePlacesId = $('#google_places_id');
        $googlePlacesPlaceId = $('#google_places_place_id');
        $googlePlacesReference = $('#google_places_reference');
        $submitSearch = $('#submit-search');
        $searchByAddressForm = $('#search-by-address-form');
        $token = $('input[name="csrfmiddlewaretoken"]');

        // HACK BK - Temporary to support initial standard html search bar which gets replaced by React
        if (searchInputContainerElement) {
            component = ReactDOM.render(
                <GooglePlacesSearchInput
                    focus={focus}
                    placeholder={placeholder}
                    size={size}
                    bounds={bounds}
                    onSuggestionSelect={this._suggestSelected}
                    value={value}
                />,
                searchInputContainerElement
            );
        }

        // clear hidden fields so that if you hit back after a search they aren't pre-filled with remembered values
        $latitude.removeAttr('value');
        $longitude.removeAttr('value');
        $googlePlacesId.removeAttr('value');
        $googlePlacesPlaceId.removeAttr('value');
        $googlePlacesReference.removeAttr('value');

        SearchByAddress.shSearchByAddress.initialize('.GooglePlacesSearchInput:first input', ({
            latitude,
            longitude,
            search_string,
            places_id,
            places_place_id,
            places_reference
        } = {}) => {
            $searchString = $('.GooglePlacesSearchInput:first input'); // HACK BK - React input in non-react page
            $latitude.val(latitude).change();
            $longitude.val(longitude).change();
            $searchString.val(search_string).change();
            $googlePlacesId.val(places_id).change();
            $googlePlacesPlaceId.val(places_place_id).change();
            $googlePlacesReference.val(places_reference).change();

            // ensure csrf token is up to date
            $token.val(StorageUtils.get('csrftoken', 'cookie'));

            if (!$searchString.val()) {
                $searchByAddressForm.attr('action', '/parking-near-me');
            }

            $searchByAddressForm.submit();
        });

        $submitSearch.on('click', () => {
            const latitude = $latitude.val();
            const longitude = $longitude.val();

            $searchString = $('.GooglePlacesSearchInput:first input'); // HACK BK - React input in non-react page

            // ensure csrf token is up to date
            $token.val(StorageUtils.get('csrftoken', 'cookie'));

            if ((!$searchString.val() || window.bypassGeocoder) && !isEmpty(latitude) && !isEmpty(longitude)) {
                // Fill in our search string if we have a prefill
                if (!$searchString.val() && !window.bypassGeocoder) {
                    $searchString.val($('#search_string_prefill').val());
                }

                if (!$searchString.val()) {
                    $searchByAddressForm.attr('action', '/parking-near-me');
                }

                // Geocoder gets bypassed when using the google places autocomplete
                $searchByAddressForm.submit();

                return false;
            }

            SearchByAddress.shSearchByAddress.lookupAddress();

            return false;
        });

        return component;
    },

    _suggestSelected({label, location, url}) {
        const searchUrl = url ? url : `/search?latitude=${location.lat}&longitude=${location.lng}&search_term=${label}`;

        window.location = searchUrl;
    }
};

export default SHGooglePlacesSearch;



// WEBPACK FOOTER //
// ./spothero/static/main/js/modules/common/search/sh-google-places-search.js